import { Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { ThemeProvider } from "@/theme/ThemeProvider";
import { AuthProvider } from "@/contexts/AuthContext";
import { ExploreCityProvider } from "@/contexts/ExploreCityContext";
import { RequireAuth, RedirectIfAuthed } from "@/components/RouteGuards";
import { AppShell } from "@/components/AppShell";
import SignIn from "./pages/SignIn";
import SignUp from "./pages/SignUp";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Onboarding from "./pages/Onboarding";
import Profile from "./pages/Profile";
import Settings from "./pages/Settings";
import Explore from "./pages/Explore";
import Leaderboard from "./pages/Leaderboard";
import CuisineDetail from "./pages/CuisineDetail";
import Feed from "./pages/Feed";
import NotFound from "./pages/NotFound";
import Landing from "./pages/Landing";

export default function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <ExploreCityProvider>
          <Routes>
          <Route
            path="/"
            element={
              <RedirectIfAuthed>
                <Landing />
              </RedirectIfAuthed>
            }
          />


          <Route
            path="/signin"
            element={
              <RedirectIfAuthed>
                <SignIn />
              </RedirectIfAuthed>
            }
          />
          <Route
            path="/signup"
            element={
              <RedirectIfAuthed>
                <SignUp />
              </RedirectIfAuthed>
            }
          />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />

          <Route
            path="/onboarding"
            element={
              <RequireAuth>
                <Onboarding />
              </RequireAuth>
            }
          />

          <Route
            element={
              <RequireAuth>
                <AppShell />
              </RequireAuth>
            }
          >
            <Route path="/home" element={<Feed />} />
            <Route path="/explore" element={<Explore />} />
            <Route path="/cuisine/:slug" element={<CuisineDetail />} />
            {/* /log is handled by the LogMealSheet opened from the bottom nav */}
            <Route path="/leaderboard" element={<Leaderboard />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/u/:username" element={<Profile />} />
          </Route>

          <Route
            path="/settings"
            element={
              <RequireAuth>
                <Settings />
              </RequireAuth>
            }
          />

          <Route path="*" element={<NotFound />} />
        </Routes>
        <Toaster />
        </ExploreCityProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}
